export default __webpack_public_path__ + "static/installation-265d102927daccdcc1205270e3a7291e.png";